import React from 'react';

/**
 * Aísla errores de render de una pregunta individual para no falle
 * el resto del formulario (grupo completo / página completa).
 */
class PreguntaErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[PreguntaErrorBoundary] Error al renderizar pregunta:', {
      pregunta: this.props.nombrePregunta,
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="pregunta-error-boundary"
          style={{
            padding: '10px 12px',
            border: '1px solid #f5c6cb',
            background: '#f8d7da',
            color: '#721c24',
            borderRadius: '4px',
            fontSize: '13px'
          }}
        >
          No se pudo mostrar esta pregunta{this.props.nombrePregunta ? ` ("${this.props.nombrePregunta}")` : ''}.
          El resto del formulario sigue disponible; contacta a soporte si el problema persiste.
        </div>
      );
    }
    return this.props.children;
  }
}

export default PreguntaErrorBoundary;
